export const messages = {
  page: {
    title: {
      id: 'pinRequired.Page.Title',
      defaultMessage: 'PIN Required',
    },
    emailMessage: {
      id: 'pinRequired.Page.EmailMessage',
      defaultMessage: 'An invitation email has been sent to {email}.',
    },
    instruction: {
      id: 'pinRequired.Page.Instruction',
      defaultMessage:
        'To protect the security of your information, the below PIN will be required to complete the sign up process.',
    },
    note: {
      id: 'pinRequired.Page.Note',
      defaultMessage:
        'We recommend that you print this PIN and provide it to {firstName} {lastName} directly.',
    },
  },
  label: {
    pin: {
      id: 'pinRequired.Label.Pin',
      defaultMessage: 'PIN: ',
    },
  },
  button: {
    print: {
      id: 'pinRequired.Button.Print',
      defaultMessage: 'Print',
    },
    done: {
      id: 'pinRequired.Button.Done',
      defaultMessage: 'Done',
    },
  },
};
